// extracted by mini-css-extract-plugin
export default {"pageWrapper":"styles_pageWrapper__7qPQa","mainWrapper":"styles_mainWrapper__AR4Dh","pageContent":"styles_pageContent__Pdy1d"};